// JsFromRoutes CacheKey 77156eda4bf6629fc93f0cdf399214fd
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client";

export default {
  execute: /* #__PURE__ */ definePathHelper("put", "/projects/jobs/:id/execute"),
  toggle: /* #__PURE__ */ definePathHelper("put", "/projects/jobs/:id/toggle")
};
